import { render, staticRenderFns } from "./BackupsTableResponsiveItem.vue?vue&type=template&id=5ef2d7d9&scoped=true"
import script from "./BackupsTableResponsiveItem.vue?vue&type=script&lang=js"
export * from "./BackupsTableResponsiveItem.vue?vue&type=script&lang=js"
import style0 from "./BackupsTableResponsiveItem.vue?vue&type=style&index=0&id=5ef2d7d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2d7d9",
  null
  
)

export default component.exports